export function decodeRoles(token: string | null): string[] {
    try {
        if (!token) return [];
        const parts = token.split('.');
        if (parts.length < 2) return [];
        const payload = parts[1];
        // Base64Url decode
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const json = JSON.parse(decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join('')));

        const realmRoles = json.realm_access?.roles || [];
        const azp = json.azp;
        const clientRoles = (azp && json.resource_access?.[azp]?.roles) || [];

        return [...realmRoles, ...clientRoles].map(r => r.toUpperCase());
    } catch (e) {
        console.error('Failed to decode token roles', e);
        return [];
    }
}

export function getHighestRole(roles: string[]): 'SUPERADMIN' | 'ADMIN' | 'READ' | null {
    if (roles.includes('SUPERADMIN')) return 'SUPERADMIN';
    if (roles.includes('ADMIN')) return 'ADMIN';
    if (roles.includes('READ')) return 'READ';
    return null;
}
